export default "__VITE_ASSET__BvtqOIhr__"